import { render } from "./DocumentPoste.vue?vue&type=template&id=7f08901c&ts=true"
import script from "./DocumentPoste.vue?vue&type=script&lang=ts"
export * from "./DocumentPoste.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__